// extracted by mini-css-extract-plugin
export default {"FooterContainer":"SimpleFooter_FooterContainer__hDuJ9"};